export default {
  title: 'Anmelden mit SSO',
  subtitle:
    'Geben Sie Ihre Firmen-E-Mail-Adresse ein, um mit Single Sign-On fortzufahren',
  continueButton: 'Mit SSO fortfahren',
  errors: {
    noSsoConfiguration:
      'Für diese E-Mail-Domain wurde keine SSO-Konfiguration gefunden. Bitte wenden Sie sich an Ihren Administrator.'
  }
};
